module.exports = __webpack_public_path__ + "assets/Heron.ccef9ced32769cca0d1c660a38489d1a.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/Heron.gmt
// module id = 953
// module chunks = 0